import { lazy } from "react";

import { MapID } from "./enums/mapIDs";

// Legend bodies are big tables of symbols, so each one is loaded only when its legend is shown
const BasicLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/BasicLegendBody").then((module) => ({
    default: module.BasicLegendBody,
  }))
);
const BubbleWrapLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/BubbleWrapLegendBody").then(
    (module) => ({
      default: module.BubbleWrapLegendBody,
    })
  )
);
const CinnabarLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/CinnabarLegendBody").then((module) => ({
    default: module.CinnabarLegendBody,
  }))
);
const RefillLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/RefillLegendBody").then((module) => ({
    default: module.RefillLegendBody,
  }))
);
const StreetLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/StreetLegendBody").then((module) => ({
    default: module.StreetLegendBody,
  }))
);
const TopoLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/TopoLegendBody").then((module) => ({
    default: module.TopoLegendBody,
  }))
);
const TronLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/TronLegendBody").then((module) => ({
    default: module.TronLegendBody,
  }))
);
const WalkaboutLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/WalkaboutLegendBody").then((module) => ({
    default: module.WalkaboutLegendBody,
  }))
);
const OutdoorsLegendBody = lazy(() =>
  import("components/LeafletMap/Legend/OutdoorsLegendBody").then((module) => ({
    default: module.OutdoorsLegendBody,
  }))
);

export const LEGENDS = {
  [MapID.basic]: BasicLegendBody,
  [MapID.bubbleWrap]: BubbleWrapLegendBody,
  [MapID.cinnabar]: CinnabarLegendBody,
  [MapID.cyclOSM]: null,
  [MapID.satellite]: null,
  [MapID.openStreetMap]: null,
  [MapID.openTopoMap]: null,
  [MapID.refill]: RefillLegendBody,
  [MapID.street]: StreetLegendBody,
  [MapID.topo]: TopoLegendBody,
  [MapID.tron]: TronLegendBody,
  [MapID.walkabout]: WalkaboutLegendBody,
  [MapID.outdoors]: OutdoorsLegendBody,
};

export const hasLegend = (mapType: MapID) => !!LEGENDS[mapType];
